import { Meta } from "@/shared/components";
import { Migrations } from "@/admin/features/migrations";

/**
 * Страница управления миграциями
 */
export function MigrationsPage() {
  return (
    <>
      <Meta title="Миграции" />
      <Migrations />
    </>
  );
}
